import { theme } from 'lib/theme';
import { StyleProp, View, ViewStyle } from 'react-native';

export const ProgressBar: React.FC<{
  progress: number;
  height?: number;
  accessibilityLabel?: string;
  containerStyle?: StyleProp<ViewStyle>;
}> = ({ progress, height = 4, accessibilityLabel, containerStyle }) => {
  const percentage = Math.min(100, Math.max(0, Math.round(progress)));

  return (
    <View
      accessibilityLabel={accessibilityLabel}
      accessibilityRole="progressbar"
      accessibilityValue={{ max: 100, min: 0, now: percentage }}
      style={[
        {
          backgroundColor: theme.colors.black10,
          borderRadius: height,
          height,
          overflow: 'hidden',
        },
        containerStyle,
      ]}
    >
      <View
        style={{
          backgroundColor: theme.colors.blue,
          height: '100%',
          width: `${percentage}%`,
          borderRadius: height,
        }}
      />
    </View>
  );
};
